export const CONTRACTING_NOTIFICATION_TEXT =
  'You have recently won one or more properties that require your attention.'
